
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { TaskAttachmentModel } from './Entities.GormCrm.TaskAttachment';
import { TransferModel } from './Entities.GormCrm.Transfer';
import { Model, ModelProperty } from 'models/Model';


export class FileReferenceModel extends Model<FileReferenceModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'userId', type: 'string' },
		{ name: 'container', type: 'string' },
		{ name: 'filePath', type: 'string' },
		{ name: 'fileName', type: 'string' },
		{ name: 'created', type: 'Date', isHidden: true },
		{ name: 'temporary', type: 'boolean' },
		{ name: 'deleted', type: 'Date', isHidden: true },
		{ name: 'taskAttachments', type: 'TaskAttachmentModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new TaskAttachmentModel }, properties: () => { return TaskAttachmentModel.classProperties } },
		{ name: 'transfers', type: 'TransferModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new TransferModel }, properties: () => { return TransferModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public userId?: string;
	public container: string;
	public filePath: string;
	public fileName: string;
	public created?: Date;
	public temporary: boolean;
	public deleted?: Date;
	public taskAttachments: TaskAttachmentModel[];
	public transfers: TransferModel[];
    
	constructor(){
		super();
		this.id = undefined;
		this.userId = undefined;
		this.container = '';
		this.filePath = '';
		this.fileName = '';
		this.created = undefined;
		this.temporary = false;
		this.deleted = undefined;
		this.taskAttachments = [];
		this.transfers = [];
		
	}
	getProperties(){
		return FileReferenceModel.classProperties;
	}
}

